import { render, staticRenderFns } from "./msgadd.vue?vue&type=template&id=05d9a14e"
import script from "./msgadd.vue?vue&type=script&lang=js"
export * from "./msgadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports